<template>
  <div class="container">
    <head-nav-bar title="签到" :fixed="true" />
    <div class="mt-header-nav">
      <ContactCard v-model="info" @change="onContactChange" @update="update" />
      <div class="buttonBox" style="width: 100%; text-align: center">
        <van-button
          type="info"
          size="normal"
          round
          @click="signIn"
          v-if="list.length"
          style="margin: 0 auto; margintop: 0.2rem"
          :disabled="!canSignInClick"
          >&nbsp;&nbsp;&nbsp;&nbsp;签到&nbsp;&nbsp;&nbsp;&nbsp;</van-button
        >
      </div>
      <!-- v-if="list.length" -->
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      style="padding: 0 0.2rem"
    >
      <div v-for="(item, index) in list" :key="index" class="list">
        <div class="infoBox">
          <van-checkbox
            v-model="item.canSignIn"
            class="checkbox"
          ></van-checkbox>
          <div class="leftBox">
            <div class="OutpatientAreaName">
              {{ item.outpatientAreaName }}
            </div>
            <div class="DepartmentName">{{ item.departmentName }}</div>
            <div class="DoctorName">医生：{{ item.doctorName }}</div>
            <div class="BookingTime">
              <div class="tittle">就诊日期</div>
              <p class="value">{{ item.bookingTime }}</p>
            </div>
          </div>

          <div class="CanSignIn">
            <!-- {{ item.CanSignIn ?  : "已签到" }} -->
            可签到
          </div>
          <div class="IsFirstTime">
            {{ item.isFirstTime ? "初诊" : "复诊" }}
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { cache } from "@/utils/common";
import ContactCard from "@/components/ContactCard";
import {
  Field,
  CellGroup,
  Button,
  List,
  CheckboxGroup,
  Checkbox,
  Dialog,
} from "vant";
export default {
  components: {
    ContactCard,
    [Dialog.name]: Dialog,
    [List.name]: List,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      canSignInClick: true,
      info: {},
      list: [],
      loading: false,
      finished: false,
      checkboxCheckList: [],
      updateData: {},
    };
  },
  created() {
    this.info = cache.get("currentContact");
  },
  methods: {
    update(e) {
      this.onLoad(e);
    },
    // 签到
    signIn() {
      this.canSignInClick = false;
      let params = {
        diagnosisCardNo: this.info.diagnosisCardNo,
        detailList: [],
      };
      // 筛选勾选的人
      this.list.map((p) => {
        if (p.canSignIn == true) {
          params.detailList.push({
            isFirstTime: p.isFirstTime,
            cardBookingId: p.cardBookingId,
            registrationId: p.registrationId,
            schedulingId: p.schedulingId,
          });
        }
      });
      setTimeout(() => {
        this.$post("SignInToQueuingUp", params).then(() => {
          this.canSignInClick = true;
          Dialog.alert({
            message: "签到成功！",
          }).then(() => {
            this.onLoad(this.info);
          });
        });
      }, 300);
    },
    // 异步更新数据
    onLoad(e) {
      this.finished = true;
      if (!e) return;
      this.$post("GetRegistrationList", {
        // OutpatientAreaId: null,
        diagnosisCardNo: this.info.diagnosisCardNo,
      }).then((res) => {
        this.list = res.data;
        this.loading = false;
        if (res.data.length) {
          res.data.map((p) => {
            if (p.canSignIn) {
              this.checkboxCheckList.push(true);
            } else {
              this.checkboxCheckList.push(false);
            }
          });
        }
        this.finished = false;
      });
    },
    onContactChange() {
      this.onLoad();
    },
  },
};
</script>

<style lang="less" scoped>
.mt-header-nav {
  box-sizing: border-box;
  // padding: 0.5rem;
  margin-bottom: 10px;
  width: 100%;
  // background-image: linear-gradient(-45deg, #63b6f8, #0f78f3);
  .member-info {
    font-size: 0.5rem;
    color: #646566;
    position: relative;
    .avatar {
      .avatar-img {
        width: 1.7rem;
        height: 1.7rem;
        border-radius: 1.7rem;
        background: rgb(204, 204, 204);
        text-align: center;
        line-height: 1.7rem;
        font-size: 0.8rem;
        color: #fff;
      }
    }
    .action {
      padding: 0.05rem 0.2rem;
      border: 1px solid #ddd;
      font-size: 0.3rem;
      border-radius: 0.5rem;
      display: inline-block;
    }
    .info {
      margin-left: 0.3rem;
      .name {
        line-height: 3.4;
      }
    }
  }
  .member-info-bottom {
    margin-top: 0.2rem;
  }
  .van-cell {
    padding: 0rem 0.4rem !important;
  }
}
.list {
  width: 100%;
  font-size: 0.4rem;
  margin-bottom: 0.5rem;
  background-color: rgba(204, 204, 204, 0.3);
  float: left;
  box-sizing: border-box;
  border-radius: 0.3rem;
  .infoBox {
    box-sizing: border-box;
    width: 100%;
    float: left;
    padding: 0.1rem 0.3rem;
    .checkbox,
    .leftBox,
    .CanSignIn,
    .IsFirstTime {
      float: left;
    }
    .OutpatientAreaName {
      font-weight: bold;
      font-size: 0.5rem;
    }
    .DepartmentName {
      font-size: 0.3rem;
      color: #999;
    }
    .BookingTime {
      // text-align: center;

      .tittle {
        font-size: 0.2rem;
        color: #999;
      }
    }
    .IsFirstTime {
      float: right;
      margin-top: 1rem;
      margin-right: 1rem;
    }
    .CanSignIn {
      margin-top: 1rem;
      margin-right: 0.2rem;
      float: right;
      color: #2aa515;
    }
    .checkbox {
      width: 1rem;
      margin-top: 1rem;
    }
  }
}
.van-checkbox {
  width: 100%;
}
.van-checkbox__label {
  width: 100% !important;
}
</style>
